import {NgModule} from '@angular/core';

import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {AcPasswordComponent} from './ac-password.component';
import {MatInputModule} from '@angular/material/input';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        MatInputModule
    ],
    declarations: [
        AcPasswordComponent,
    ],
    entryComponents: [
        AcPasswordComponent,
    ],
    exports: [
        AcPasswordComponent,
    ]
})
export class AcPasswordModule {
}
